export const classes = {
  root: {
    zIndex: '3001 !important',
    '& .MuiBackdrop-invisible': {
      backgroundColor: 'transparent',
    },
  },
  paper: {
    '&.MuiMenu-paper.MuiPaper-root': {
      borderRadius: 4,
    },
  },
};
